import { Vector3 } from "@babylonjs/core";
import { ClipIndex, ClipPlaneDefinition, HolographicBoundsType } from "./display.holographic.bounds";
import { VirtualDisplay } from "./display.virtual";
import { Observable } from "core/events";
export class HolographicDisplay extends VirtualDisplay {
    static BuildLateralClipPlanes(display) {
        const clipPlanes = new Array();
        const halfWidth = display.halfDimension.width;
        const halfHeight = display.halfDimension.height;
        const nNorth = new Vector3(0, 1, 0);
        const nSouth = new Vector3(0, -1, 0);
        const nEast = new Vector3(1, 0, 0);
        const nWest = new Vector3(-1, 0, 0);
        const position = display.node.position;
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.North, position.add(nNorth.scale(halfHeight)), nSouth));
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.South, position.add(nSouth.scale(halfHeight)), nNorth));
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.East, position.add(nEast.scale(halfWidth)), nWest));
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.West, position.add(nWest.scale(halfWidth)), nEast));
        return clipPlanes;
    }
    static buildHorizontalClipPlanes(display) {
        const clipPlanes = new Array();
        const halfThickness = display.halfDimension.depth;
        const nTop = new Vector3(0, 0, 1);
        const nBottom = new Vector3(0, 0, -1);
        const position = display.node.position;
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.Top, position.add(nTop.scale(halfThickness)), nBottom));
        clipPlanes.push(new ClipPlaneDefinition(ClipIndex.Bottom, position.add(nBottom.scale(halfThickness)), nTop));
        return clipPlanes;
    }
    constructor(name, dimension, resolution, scene) {
        super(name, dimension, resolution, scene);
        this._clipPlanes = null;
        this._clipPlanes = HolographicDisplay.BuildLateralClipPlanes(this).concat(HolographicDisplay.buildHorizontalClipPlanes(this));
    }
    get clipPlanesAddedObservable() {
        if (!this._clipPlanesAddedObservable) {
            this._clipPlanesAddedObservable = new Observable();
        }
        return this._clipPlanesAddedObservable;
    }
    get clipPlanesRemovedObservable() {
        if (!this._clipPlanesRemovedObservable) {
            this._clipPlanesRemovedObservable = new Observable();
        }
        return this._clipPlanesRemovedObservable;
    }
    get clipPlanes() {
        return this._clipPlanes;
    }
    get clipPlanesWorld() {
        if (!this._clipPlanes || this._clipPlanes.length === 0)
            return null;
        const world = new Array();
        const transform = this.node.getWorldMatrix();
        for (const plane of this._clipPlanes) {
            const p = Vector3.TransformCoordinates(plane.point, transform);
            const n = Vector3.TransformNormal(plane.normal, transform);
            world.push(new ClipPlaneDefinition(plane.index, p, n));
        }
        return world;
    }
    get type() {
        return HolographicBoundsType.BOX;
    }
}
//# sourceMappingURL=display.holographic.js.map